import { createSlice } from '@reduxjs/toolkit'
import { PlayerPoachInfo } from '../sdk/model'
import { enableMapSet } from 'immer';

enableMapSet();

const initialState : Record<string, PlayerPoachInfo[]> = {};

const playerPoachDataLoadSlice = createSlice({
  name: 'playerPoachDataLoad',
  initialState,
  reducers: {
    setPlayerPoachDataLoad (state, action) {
      return state = action.payload
    }
  }
})

export const { setPlayerPoachDataLoad } = playerPoachDataLoadSlice.actions
export default playerPoachDataLoadSlice.reducer